<template lang="">
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Start Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
<div class="app-section doc-wrapper doc-inner">
    <div class="row">
        <div class="col-xl-12">
            <div class="app-wrapper">
                <h2 class="inner-title">App Configuration Guide</h2>
                <small class="pb-20">Follow these steps to set up the app with your information inside the project files:</small>
                <ul class="configure-list">
                    <li class="mb-10"><b>Set Domain</b>
                        <ol>
                            <li><b>Domain Configuration:</b> Navigate to <code>lib/backend/services_and_models/api_endpoint.dart</code> file and replace the domain with your own. Ensure to update all API endpoints with your domain.</li>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/appInstallation/domain_configuration.webp" alt="app">
                                    </a>
                                </div>
                            </div>
                        </ol>
                    </li>
                    <li class="mb-10"><b>Logo/Icon Change</b>
                        <ol>
                            <li><b>Logo/Icon Replacement:</b> Go to the <code>/assets/logo/</code> directory and replace all image files with your custom logos/icons. Ensure to keep the file names unchanged.</li>
                            <ul>
                                <li>App Icon (Android) - Size: 512 x 512 px - Format: PNG - Maximum file size: 1024 KB</li>
                                <li>App Icon (iOS) - Size: 1024 x 1024 px - Format: JPEG (without alpha, no transparency)</li>
                            </ul>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/appInstallation/logo_replacement.webp" alt="app">
                                    </a>
                                </div>
                            </div>
                        </ol>
                    </li>
                    <li class="mb-10"><b>Package Name and App Launcher Name-Icon Change</b>
                        <ol>
                            <li><b>Package Name and App Launcher Configuration:</b> Open the <code>/pubspec.yaml</code> file and update the <code>flutter_icons</code> section with the path to your launcher icon. Also, update the <code>name</code> field with your desired app name.</li>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/appInstallation/app_launcher_configure.webp" alt="app">
                                    </a>
                                </div>
                            </div>
                            <li><b>Run Commands:</b> Execute the following commands in your terminal:</li>
                            <div class="cmd-run">flutter pub get <br> flutter pub run flutter_app_name <br> flutter pub run flutter_launcher_icons <br> flutter pub run change_app_package_name:main com.new.package.name</div>
                            <small><span class="text--danger">Note</span> Replace <code>com.new.package.name</code> with your desired package name.</small>
                            <li><b>Revert Changes:</b>  After running the commands, revert the changes made in the files by uncommenting and commenting out the marked lines of code.</li>
                        </ol>
                        <div class="row">
                            <div class="col-xl-7">
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/appInstallation/revert_changes.webp" alt="app">
                                </a>
                            </div>
                        </div>
                    </li>
                    <li class="mb-10"><b>Additional Note</b>
                        <ol>
                            <li><b>Device Installation:</b> It’s recommended to use a real device for installing the app, as emulators/simulators may not always function correctly.</li>
                        </ol>
                    </li>
                    <p><b class="text--danger">Conclusion:</b> By following these steps and executing the provided commands, you can configure the app with your own domain, logos/icons, package name, and app launcher name. Ensure to test the app thoroughly after making these changes to ensure everything is functioning as expected. If you encounter any issues during the configuration process, refer to the documentation or seek assistance from the Flutter community. Happy app customization!</p>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="page-change-area">
    <div class="navigation-wrapper">
        <router-link :to="{ name: 'FlutterEnvironmentSetup'}" class="left"><i class="las la-angle-left me-1"></i> Flutter Environment Setup</router-link>
        <router-link :to="{ name: 'DevelopmentAndTesting'}" class="right">Development and Testing <i class="las la-angle-right ms-1"></i></router-link>
    </div>
</div>
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    End Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
</template>
<script>
export default {
    name: 'AppInstallationPage',
}
</script>